<template>
  <div class="l-main" :class="showMap" @mouseup="onMouseUp">
    <div class="l-submain" :class="currentSize" 
      @mousemove="l_submain_onMouseMove" @mouseleave="l_submain_onMouseLeave"
    >
      <div class="l-table-wrap">
        <div class="l-table-bar ">
          <v-card>
          <v-layout row  >
            <v-flex xs12 sm8 md6 class="pl-2 white">
              <span class="body-2">
              {{$t("watersystem.list")}}:
              </span>
              <v-btn round depressed small
                :class="[isCustomerFormat?'blue lighten-5 blue--text':'grey--text']"
                @click="getLocations">
                <v-icon class="body-1">place</v-icon>
                <span>{{$t("watersystem.customer")}}</span>
              </v-btn>
              <v-btn round depressed small
                :class="[isCustomerFormat?'grey--text':'blue lighten-5 blue--text']"
                @click="getAllFiltrationSystems">
                <v-icon class="caption">smartphone</v-icon>
                <span>{{$t("watersystem.device")}}</span>
              </v-btn>
            </v-flex>
          </v-layout>
        </v-card>

        <!-- ヘッダー：顧客リストモード-->
        <div v-show="isCustomerFormat">
          <v-card>
            <v-layout row class="pt-2 pb-2 caption elevation-1">
              <v-flex xs1 class="text-xs-center"
                @click="toggleSortOrder(
                  'status',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.status")}}
                  <v-icon small>{{computeArrowSortOrder('status', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs1 class="text-xs-center"
                @click="toggleSortOrder(
                  'mapinfo',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.mapinfo")}}
                  <v-icon small>{{computeArrowSortOrder('mapinfo', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs3
                @click="toggleSortOrder(
                  'locationName',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.customer-name")}}
                  <v-icon small>{{computeArrowSortOrder('locationName', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs3
                @click="toggleSortOrder(
                  'organizationName',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.organization-name")}}
                  <v-icon small>{{computeArrowSortOrder('organizationName', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs3
                @click="toggleSortOrder(
                  'services',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.service")}}
                  <v-icon small>{{computeArrowSortOrder('services', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs1
                @click="toggleSortOrder(
                  'devices',
                  ordersLocations,
                  defaultOrdersLocations,
                  locations)"
              >
                <a class="sortable">
                  {{$t("watersystem.device")}}
                  <v-icon small>{{computeArrowSortOrder('devices', ordersLocations)}}</v-icon>
                </a>
              </v-flex>
            </v-layout>
          </v-card>
        </div>

        <!-- ヘッダー：デバイスリストモード-->
        <div v-show="!isCustomerFormat">
          <v-card >
            <v-layout row class="pa-2 caption elevation-1">
              <v-flex xs2 class="text-xs-center"
                @click="toggleSortOrder(
                  'status',
                  ordersDevices,
                  defaultOrdersDevices,
                  devices)"
              >
                <a class="sortable">
                  {{$t("watersystem.status")}}
                  <v-icon small>{{computeArrowSortOrder('status', ordersDevices)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs4
                @click="toggleSortOrder(
                  'filtrationSystemName',
                  ordersDevices,
                  defaultOrdersDevices,
                  devices)"
              >
                <a class="sortable">
                  {{$t("watersystem.device-name")}}
                  <v-icon small>{{computeArrowSortOrder('filtrationSystemName', ordersDevices)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs3
                @click="toggleSortOrder(
                  'locationName',
                  ordersDevices,
                  defaultOrdersDevices,
                  devices)"
              >
                <a class="sortable">
                  {{$t("watersystem.customer-name")}}
                  <v-icon small>{{computeArrowSortOrder('locationName', ordersDevices)}}</v-icon>
                </a>
              </v-flex>
              <v-flex xs3
                @click="toggleSortOrder(
                  'dispServices',
                  ordersDevices,
                  defaultOrdersDevices,
                  devices)"
              >
                <a class="sortable">
                  {{$t("watersystem.service")}}
                  <v-icon small>{{computeArrowSortOrder('dispServices', ordersDevices)}}</v-icon>
                </a>
              </v-flex>
            </v-layout>
          </v-card>
        </div>
        </div>

        <!-- テーブル -->
        <div :class="['l-table', isCustomerFormat ? 'locations' : '']" >

          <!--顧客リスト-->
          <div v-if="isCustomerFormat&&locations.length!=0">
            <v-expansion-panel expand id="locations_table">
              <v-expansion-panel-content
                class="grey lighten-4"
                style="border-bottom:1px solid #CCC !important"
                v-for="(location,i) in locations" :key="i" ref="customerExpands">
                <v-layout id="expansion_row" slot="header" @click="getEachFiltrationSystems(location.locationId,i,$event)">
                  <v-flex xs1 class="text-xs-center">
                    <v-icon
                    v-if="location.locationStatus"
                    :class="location.locationStatus==1?'orange--text':'red--text'" class="body-2">
                      fiber_manual_record
                    </v-icon>
                  </v-flex>
                  <v-flex xs1 class="text-xs-center">
                    <v-btn class="d-inline-block map_btn ma-0 white" small depressed v-if="location.latitude != null && location.longitude != null"  @click.stop="centerMapLocation(location.latitude, location.longitude)">
                      <i class="fa fa-map-marker"></i>
                    </v-btn>
                  </v-flex>
                  <v-flex xs3>{{location.locationName}}</v-flex>
                  <v-flex xs3 class="grey--text">{{location.organizationName}}</v-flex>
                  <v-flex xs3 class="service-header">
                    <span v-for="(serviceId, index) in location.services">
                      <span v-if="index!=0">,&nbsp;</span>
                      {{shortServiceNames[serviceId]}}
                    </span>
                  </v-flex>
                  <v-flex xs1 :class="location.activeDevices==0?'grey--text text--lighten-2':''">{{location.activeDevices}}</v-flex>
                </v-layout>
                <v-card v-if="!location.filtrationSystems">
                  <v-progress-linear height="2" :indeterminate="true"></v-progress-linear>
                </v-card>
                <v-list>


                  <!-- 各ロケーションごとのデバイスリスト -->
                  <template v-for="filtrationSystem in location.filtrationSystems">
                    <v-list-tile
                      class="ma-0 pa-0"
                      :class="filtrationSystem.filtrationSystemId==selectedFiltrationSystemId?'blue lighten-4':'white'"
                      v-bind:key="filtrationSystem.filtrationSystemId"
                      @click.stop="showFiltrationSystem(filtrationSystem.filtrationSystemId)"
                      >
                        <v-layout row wrap class="body-2 grey--text text--darken-2"  >
                          <v-flex xs1 class="text-xs-center">
                            <!-- 描画時にステータスの診断。boolean返すだけではDOMに反映されなかった。 -->
                            {{statusCheck(filtrationSystem)}}
                            <v-icon
                              v-if="filtrationSystem.status !== 0"
                              :class="filtrationSystem.statusCssClass"
                              class="body-2">
                              fiber_manual_record
                            </v-icon>
                          </v-flex>
                          <v-flex xs3 offset-xs1>{{filtrationSystem.filtrationSystemName}}</v-flex>
                          <v-flex xs3></v-flex>
                          <v-flex xs2>
                            <span v-for="(service, index) in filtrationSystem.dispServices">
                              <span v-if="index!=0">,&nbsp;</span>
                              {{shortServiceNames[service.serviceId]}}
                            </span>
                          </v-flex>
                          <v-flex xs1>{{filtrationSystem.jm1UniqueId}}</v-flex>
                        </v-layout>
                      <div v-if="userRole!==viewerRoleName">
                        <v-menu  left offset-y ref="waterSystemMenu">
                          <v-btn small flat icon slot="activator" @click="showWaterSystemSettingsMenu">
                            <v-icon class="caption grey--text">settings</v-icon>
                          </v-btn>
                          <v-list>
                            <v-list-tile @click.stop="showWaterSystemDeleteDialog(filtrationSystem)">
                              {{$t('btn.delete')}}
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </div>
                    </v-list-tile>
                    <v-divider/>
                  </template>

                </v-list>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </div>

          <!--顧客リスト：顧客がいない場合-->
          <div v-if="isCustomerFormat&&locations.length==0">
            <div class="pa-3" v-if="message">
              {{message}} <router-link to="/customer_list">here</router-link>.
            </div>
          </div>

          <!--デバイスリスト-->
          <div v-if="!isCustomerFormat&&devices.length!=0">
            <v-list class="pb-0" dense>
              <template v-for="device in devices">
                <v-list-tile
                  row @click.stop="showFiltrationSystem(device.filtrationSystemId)"
                  :class="device.filtrationSystemId==selectedFiltrationSystemId?'blue lighten-4':'white'">
                  <v-flex xs2 class="text-xs-center">
                    <!-- 描画時にステータスの診断。boolean返すだけではDOMに反映されなかった。。。 -->
                    {{statusCheck(device)}}
                    <v-icon
                      v-if="device.status !== 0"
                      :class="device.statusCssClass"
                      class="body-2 pl-2">
                      fiber_manual_record
                    </v-icon>
                  </v-flex>
                  <v-flex xs4>{{device.filtrationSystemName}} <span class="grey--text">({{device.jm1UniqueId}})</span></v-flex>
                  <v-flex xs3>{{device.locationName}}</v-flex>
                  <v-flex xs3>
                    <span v-for="(service, index) in device.dispServices">
                      <span v-if="index!=0">,&nbsp;</span>
                      {{shortServiceNames[service.serviceId]}}
                      </span>
                    </v-flex>
                    <div v-if="userRole!==viewerRoleName">
                      <v-menu  left offset-y ref="waterSystemMenu">
                        <v-btn small flat icon slot="activator" @click="showWaterSystemSettingsMenu">
                          <v-icon class="caption grey--text">settings</v-icon>
                        </v-btn>
                        <v-list>
                          <v-list-tile @click.stop="showWaterSystemDeleteDialog(device)">
                            {{$t('btn.delete')}}
                          </v-list-tile>
                        </v-list>
                      </v-menu>
                    </div>
                </v-list-tile>
                <v-divider/>
              </template>
            </v-list>
          </div>

          <!--デバイスリスト：デバイスがない場合-->
          <div v-if="!isCustomerFormat&&devices.length==0">
            <div class="pa-3" v-if="message">
              {{message}}
            </div>
          </div>


        </div><!-- l-table -->
      </div><!-- l-table-wrap -->

      <div class="l-detail-wrap">
        <div class="l_detail_bar lighten-1" 
          @mousedown="l_detail_bar_onMouseDown"
        >
          <v-layout class="white--text ">
            <v-flex class="pt-2 pl-2">
              <p>{{$t("watersystem.deviceinfo")}}</p>
            </v-flex>
            <v-spacer></v-spacer>
            <div class="pt-1">
              <v-icon class="white--text mr-4 icon-hover" @click.stop="changeSize('max')">vertical_align_top</v-icon>
              <v-icon class="white--text mr-4 icon-hover" @click.stop="changeSize('mid')">vertical_align_center</v-icon>
              <v-icon class="white--text mr-5 icon-hover" @click.stop="changeSize('min')">vertical_align_bottom</v-icon>
            </div>
          </v-layout>
        </div>
        <div class="l-detail">

          <!-- デバイス情報 -->
          <water-system
            ref="filtrationSystem"
            @child-action="centerMapLocation"
            @delete-succeed="reloadWaterSystemList"
          >
          </water-system>
        </div>
      </div>
    </div>
    <div class="l-map">
        <v-btn @click="mapToggle" dark small color="grey" absolute class="map_float_btn map_btn elevation-5">
            <v-icon v-if="active">keyboard_arrow_right</v-icon>
            <v-icon v-else>keyboard_arrow_left</v-icon>
        </v-btn>
      <div :id="mapName" style="position: relative; width: 100%; min-height: 90vh; border-left: 3px solid #AAA;"></div>
    </div>
    <water-system-delete-dialog ref="waterSystemDeleteDialog" @delete-succeed="reloadWaterSystemList"/>
  </div>
</template>

<script>
/* eslint spaced-comment: 0 */
/* eslint no-tabs: 0 */
/* eslint no-mixed-spaces-and-tabs: 0 */
/* eslint key-spacing: 0 */
/* eslint padded-blocks: 0 */
/* eslint no-trailing-spaces: 0 */
/* eslint space-before-blocks: 0 */
/* eslint eqeqeq: 0 */
/* eslint space-before-function-paren: 0 */
/* eslint no-multiple-empty-lines: 0 */
/* eslint quotes: 0 */
/* eslint brace-style: 0 */
/* eslint comma-style: 0 */
/* eslint operator-linebreak: 0 */
/* eslint keyword-spacing: 0 */
/* eslint camelcase: 0 */
/* eslint comma-dangle: 0 */
/* eslint yoda: 0 */
/* eslint indent: 1 */
/* eslint no-unreachable: 1 */
/* eslint no-unused-vars: 1 */
import config from '@/config.js'
import http from '@/utils/http.js'
import utils from '@/utils/utils.js'
import statuscheck from '@/utils/statuscheck.js'
import WaterSystem from '@/components/WaterSystem.vue'
import WaterSystemDeleteDialog from '@/components/WaterSystemDeleteDialog.vue'

export default {
  name: 'SystemList',
  components: {
    WaterSystem,
    WaterSystemDeleteDialog
  },
  data () {
    return {
      userRole: this.$store.getters.user.roles[0]['name'],
      viewerRoleName: config.role.Viewer,
      user: this.$store.getters.user, // ログインユーザ
      locations: [],
      devices: [],
      selectedFiltrationSystemId: null,
      expandedLocations: [],
      message: '',
      shortServiceNames: this.$store.getters.serviceList.shortNames,
      isShowWaterSystemSettingsMenu: false,

      // 表示形式が拠点リストかデバイスリストかどうか
      isCustomerFormat: this.$store.getters.isCustomerFormat,

      // ----- map -----
      mapName: 'map',
      map: null,
      zoom: 13,
      bounds: null,
      points: [],
      markers: [],
      firstStartup: true,
      callingShowPointData: false,

      // 表示切り替え用 デフォルト
      active: true,
      size: 'min',
      l_detail_bar_grabbed: false,
      HISTORY_style_bak: null,

      // ソート順
      defaultOrdersLocations: [{key: 'organizationId', isAsc: true}, {key: 'locationId', isAsc: true}], // デフォルトソート順(設置拠点)
      defaultOrdersDevices: [{key: 'filtrationSystemId', isAsc: true}], // デフォルトソート順(デバイス)
      ordersLocations: [], // デフォルトソート順(設置拠点)
      ordersDevices: [], // デフォルトソート順(デバイス)
      defaultLocations: [], // 初期表示のリスト(設置拠点)
      defaultDevices: [] // 初期表示のリスト(デバイス)
    }
  },
  computed: {
    showMap () {
      return {
        'active': this.active
      }
    },
    currentSize () {
      return {
        'max': (this.size === 'max'),
        'mid': (this.size === 'mid'),
        'min': (this.size === 'min'),
        'none': (this.size === 'none')
      }
    }
  },
  methods: {
    init () {
      if (this.$route.params.id) {
        this.changeSize('max')
        this.$refs.filtrationSystem.init(this.$route.params.id)
        this.selectedFiltrationSystemId = this.$route.params.id
      }
      this.initMap()
      if (this.isCustomerFormat) {
        this.getLocations()
      } else {
        this.getAllFiltrationSystems()
      }
    },
    // ステータスをソート用に変換
    convertStatusForSort (element) {
      let status = 0
      if (this.isCustomerFormat) {
        // 設置拠点.ステータスの昇順ならred、orange、blueの順
        let locationElement = element
        status = locationElement.locationStatus
      } else {
        // デバイス.ステータスの昇順ならstatusがred、orange、blueの順
        let filtrationSystem = element
        status = statuscheck.getFiltrationSystemStatusValue(filtrationSystem)
      }
      switch (status) {
        case 2: // alert
          return 0
        case 1: // warning
          return 1
        case 0: // good
        default:
          return 2
      }
    },
    // 位置情報をソート用に変換
    convertMapInfoForSort (locationElement) {
      // 設置拠点.位置情報の昇順なら位置情報あり、位置情報なしの順
      return locationElement.latitude !== null && locationElement.longitude !== 0 ? 0 : 1
    },
    // ソート用比較 共通
    comparateCommon (a, b, isAsc = false) {
      let comparatedLessA = -1
      let comparatedLessB = 1
      if (!isAsc) {
        comparatedLessA = 1
        comparatedLessB = -1
      }
      let comparated = 0
      if (a < b) {
        comparated = comparatedLessA
      } else if (b < a) {
        comparated = comparatedLessB
      }
      return comparated
    },
    // 指定されたソート順(フィールド名、昇順/降順指定)で比較
    comparateForSort (a, b, sortOrder) {
      let comparated = 0
      // console.info([a, b])
      // サービス、設置拠点、デバイス数の場合はサービス、デバイス数でソート
      const countBySortKeys = ['services', 'devices', 'dispServices']
      if (sortOrder.key === 'status') {
        // ステータスの場合はステータスをソート用に変換して比較
        comparated = this.comparateCommon(this.convertStatusForSort(a), this.convertStatusForSort(b), sortOrder.isAsc)
      } else if (sortOrder.key === 'mapinfo') {
        // 位置情報の場合は位置情報をソート用に変換して比較
        comparated = this.comparateCommon(this.convertMapInfoForSort(a), this.convertMapInfoForSort(b), sortOrder.isAsc)
      } else if (countBySortKeys.indexOf(sortOrder.key) > -1) {
        // サービス、設置拠点、デバイス数の場合はサービス数、デバイス数でソート(初回クリック時は降順、2回目クリック時は昇順)
        comparated = this.comparateCommon(a[sortOrder.key].length, b[sortOrder.key].length, sortOrder.isAsc)
      } else if (sortOrder.key === 'servicesName') {
        // 設置拠点.サービス名のソートの場合は設置拠点.サービスIDの順でソート
        comparated = this.comparateCommon(
          a.services.join(' '),
          b.services.join(' '),
          sortOrder.isAsc
        )
      } else if (sortOrder.key === 'dispServicesName') {
        // デバイス.サービス名のソートの場合は設置拠点.表示用サービス.サービスIDの順でソート
        comparated = this.comparateCommon(
          a.dispServices.map(service => service.serviceId).join(' '),
          b.dispServices.map(service => service.serviceId).join(' '),
          sortOrder.isAsc
        )
      } else {
        // 指定された順でソート(小文字変換後に比較後、元の値で比較)
        if (typeof a[sortOrder.key] === 'string') {
          comparated = this.comparateCommon(a[sortOrder.key].toLowerCase(), b[sortOrder.key].toLowerCase(), sortOrder.isAsc)
        }
        if (comparated === 0) {
          comparated = this.comparateCommon(a[sortOrder.key], b[sortOrder.key], sortOrder.isAsc)
        }
      }
      // console.info(sortOrder.key, [a[sortOrder.key], b[sortOrder.key]])
      return comparated
    },
    // ソート実施
    sortBySortOrder (list, sortOrders) {
      list.sort((a, b) => {
        let comparated = 0
        sortOrders.some((sortOrder, index) => {
          comparated = this.comparateForSort(a, b, sortOrder)
          if (comparated !== 0) {
            return true
          }
        })
        return comparated
      })
      return list
    },
    // ソート順に合わせた矢印を導出
    computeArrowSortOrder (key, sortOrders) {
      const existsSortOrderIndex = sortOrders.slice().map(sortOrder => sortOrder.key).indexOf(key)
      if (existsSortOrderIndex === -1) {
        return ''
      }
      if (sortOrders[existsSortOrderIndex].isAsc) {
        return 'arrow_upward'
      } else {
        return 'arrow_downward'
      }
    },
    // クリックしたらソート順をトグルし、ソートする
    toggleSortOrder (key, sortOrders, defaultOrders, list) {
      let existsSortOrderIndex = sortOrders.slice().map(sortOrder => sortOrder.key).indexOf(key)
      let existsSortOrder = null
      if (existsSortOrderIndex > -1) {
        existsSortOrder = sortOrders[existsSortOrderIndex]
      }
      // サービス、設置拠点.デバイスの場合は初回クリック時は降順
      const firstClickDescKeys = ['services', 'devices', 'dispServices']
      if (existsSortOrder === null) {
        // ソートキーは１つまで(拡張要件があれば削除)
        if (sortOrders.length > 0) {
          sortOrders.splice(0, 1)
        }
        // サービス、設置拠点.デバイスの場合は初回クリック時は降順
        sortOrders.push({key: key, isAsc: firstClickDescKeys.indexOf(key) === -1})
      } else if (existsSortOrder.isAsc && firstClickDescKeys.indexOf(key) === -1) {
        // サービス、設置拠点.デバイス以外の場合、2回目クリック時は降順
        sortOrders[existsSortOrderIndex].isAsc = false
      } else if (!existsSortOrder.isAsc && firstClickDescKeys.indexOf(key) > -1) {
        // サービス、設置拠点.デバイスの場合、2回目クリック時は昇順
        sortOrders[existsSortOrderIndex].isAsc = true
      } else {
        // 3回目クリック時はデフォルトソート
        sortOrders.splice(existsSortOrderIndex, 1)
      }

      // 画面上で選択されたソート順を元に実際にソートする順序を作成
      let sortOrdersReal = JSON.parse(JSON.stringify(sortOrders))
      if (this.isCustomerFormat && key === 'services' && sortOrders.length > 0) {
        // 設置拠点.サービスを選択した場合はサービス名の昇順ソートをサービス数の次のソート順として指定
        existsSortOrderIndex = sortOrdersReal.slice().map(sortOrder => sortOrder.key).indexOf(key)
        sortOrdersReal.splice(existsSortOrderIndex + 1, 0, {key: 'servicesName', isAsc: true})
      } else if (!this.isCustomerFormat && key === 'dispServices' && sortOrders.length > 0) {
        // デバイス.サービスを選択した場合はサービス名の昇順ソートをサービス数の次のソート順として指定
        existsSortOrderIndex = sortOrdersReal.slice().map(sortOrder => sortOrder.key).indexOf(key)
        sortOrdersReal.splice(existsSortOrderIndex + 1, 0, {key: 'dispServicesName', isAsc: true})
      }
      // デフォルトソート順を末尾に追加
      sortOrdersReal = sortOrdersReal.concat(defaultOrders)

      // ソート実施
      if (this.isCustomerFormat) {
        // 開いていたデバイス表示は一旦全部閉じる
        this.$refs.customerExpands.forEach(expand => {
          expand.isActive = false
        })
        if (sortOrders.length === 0) {
          this.locations = this.dispServicesAdds(this.deepCopyJson(this.defaultLocations))
        } else {
          this.locations = this.sortBySortOrder(list, sortOrdersReal)
        }
        // 開いていたデバイス表示を再び開く
        this.locations.forEach((locationEle, index) => {
          const expandedIndex = this.expandedLocations.indexOf(locationEle.locationId)
          if (expandedIndex > -1) {
            if (locationEle.filtrationSystems === undefined) {
              this.getEachFiltrationSystems(locationEle.locationId, index)
            }
            this.$refs.customerExpands[index].isActive = true
          } else {
            this.$refs.customerExpands[index].isActive = false
          }
        }, this)
      } else {
        if (sortOrders.length === 0) {
          this.devices = this.dispServicesAdds(this.deepCopyJson(this.defaultDevices))
        } else {
          this.devices = this.sortBySortOrder(list, sortOrdersReal)
        }
      }
      console.log({orders: sortOrders, real: sortOrdersReal, default: defaultOrders})
    },
    deepCopyJson (o) {
      let cache = []
      let copyO = JSON.parse(JSON.stringify(o, function (key, value) {
        if (typeof value === 'object' && value !== null) {
          if (cache.indexOf(value) !== -1) {
            // Duplicate reference found
            try {
              // If this value does not reference a parent it can be deduped
              return JSON.parse(JSON.stringify(value))
            } catch (error) {
              // discard key if value cannot be deduped
              return
            }
          }
          // Store value in our collection
          cache.push(value)
        }
        return value
      }))
      cache = null
      return copyO
    },
    getLocations () {
      this.expandedLocations = []
      this.ordersLocations = []
      this.ordersDevices = []
      this.defaultLocations = []
      this.defaultDevices = []

      http.request('get', '/service2/dashboard/api/Organizations/locationList')
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location data failed. (' + data.result + ')')
            return
          }
          this.locations = this.sortBySortOrder(data.locations, this.defaultOrdersLocations)
          this.defaultLocations = JSON.parse(JSON.stringify(data.locations))
          this.dataTotal = data.locations.length
          if (this.dataTotal === 0) this.message = 'It seems there is no customer. please add'

          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'customer')
          this.isCustomerFormat = true
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getAllFiltrationSystems () {
      this.expandedLocations = []
      this.ordersLocations = []
      this.ordersDevices = []
      this.defaultLocations = []
      this.defaultDevices = []

      http.request('post', '/service2/dashboard/api/organizations/filtrationSystemList', {needReplace: false})
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get all filtration systems failed. (' + data.result + ')')
            return
          }
          this.devices = this.sortBySortOrder(this.dispServicesAdds(data.filtrationSystems), this.defaultOrdersDevices)
          this.defaultDevices = this.deepCopyJson(data.filtrationSystems)
          if (this.devices.length === 0) this.message = 'It seems there is no devices. please install with IoTIZR.'

          this.$store.commit('SET_WATERSYSTEM_DISPLAYMODE', 'device')
          this.isCustomerFormat = false
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    getEachFiltrationSystems (locationId, key) {
      http.request('get', '/service2/dashboard/api/Locations/getDetail/' + locationId)
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get location data failed. (' + data.result + ')')
            return
          }
          let filtrationSystems = this.sortBySortOrder(this.dispServicesAdds(data.devices), this.defaultOrdersDevices)
          // 該当ロケーションに浄水システムの一覧情報を追加。
          this.$set(this.locations[key], 'filtrationSystems', filtrationSystems)
          const isExpandedRow = this.$refs.customerExpands[key].isActive
          if (isExpandedRow && filtrationSystems.length > 0) {
            const expandedIndex = this.expandedLocations.indexOf(locationId)
            if (expandedIndex === -1) {
              this.expandedLocations.push(locationId)
            }
          } else {
            const expandedIndex = this.expandedLocations.indexOf(locationId)
            if (expandedIndex > -1) {
              this.expandedLocations.splice(expandedIndex, 1)
            }
          }
          if (filtrationSystems.length === 0) {
            this.$refs.customerExpands[key].isActive = false
          }
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
        })
    },
    showFiltrationSystem (filtrationSystemId) {
      if (this.isShowWaterSystemSettingsMenu) {
        this.isShowWaterSystemSettingsMenu = false
        return
      }
      if (this.size != 'mid'){
        this.changeSize('mid')
      }
      this.$router.push('/watersystem_list/' + filtrationSystemId)
      this.selectedFiltrationSystemId = filtrationSystemId
      this.$refs.filtrationSystem.init(filtrationSystemId)
    },
    statusCheck (filtrationSystem) {
      // サービス総じてのステータスのチェックを行う （本来はサーバでやったほうが良さそう）
      const status = statuscheck.getFiltrationSystemStatusValue(filtrationSystem)

      // filtrationSystemのプロパティに追加する（そうしないとDOMに反映されない）
      this.$set(filtrationSystem, 'status', status)
      this.$set(filtrationSystem, 'statusCssClass', statuscheck.getCssClassForStatus(status, '--text'))
      return
    },
    statusCheckService (service) {
      var alert = 'red'
      var warning = 'orange'
      var good = 'blue'
      switch (service.status) {
        case 0:
          return good
        case 1:
          return warning
        case 2:
          return alert
        default:
          return good
      }
    },
    dispServicesAdds (data) {
      return utils.dispServicesAdds(data)
    },
    initMap () {
      let self = this
      /* eslint-disable no-new */
      /* global google */
      this.map = new google.maps.Map(document.getElementById(this.mapName), {
        center: new google.maps.LatLng(51.4768467, -0.0005284),
        zoom: 13,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        streetViewControl: false,
        mapTypeControlOptions: {
          position: google.maps.ControlPosition.RIGHT_BOTTOM
        },
        zoomControlOptions: {
          position: google.maps.ControlPosition.RIGHT_CENTER
        }
      })

      google.maps.event.addListener(this.map, 'idle', function () {
        self.zoom = self.map.getZoom()
        self.bounds = self.map.getBounds()
        // console.log('idle')
        self.showPointData()
      })

      google.maps.event.addListener(this.map, 'dragend', function () {
        self.bounds = self.map.getBounds()
        // console.log('dragend')
        self.showPointData()
      })

      // 一番最初に地図を表示した時の初期化
      google.maps.event.addListenerOnce(this.map, 'bounds_changed', function () {
        self.bounds = self.map.getBounds()
        // console.log('bounds_changed')
        self.showPointData()
      })
    },
    // ----- map ------------------------------
    showPointData () {
      if (!this.callingShowPointData) {
        this.callingShowPointData = true
        http.request('post', '/service2/dashboard/api/locations/points', {
          zoom: this.zoomRounded(),
          northEastLat: this.bounds.getNorthEast().lat(),
          northEastLng: this.bounds.getNorthEast().lng(),
          southWestLat: this.bounds.getSouthWest().lat(),
          southWestLng: this.bounds.getSouthWest().lng()
        })
        .then(response => {
          const data = response.data
          if (data.result !== 0) {
            // TODO エラー処理
            console.log('get account data failed. (' + data.result + ')')
            this.callingShowPointData = false
            return
          }
          this.points = data.locations
          this.createMarker(data.locations)
          if (this.firstStartup) {
            if (data.locations.length > 0) {
              this.centerMapLocation(data.locations[0].latitude, data.locations[0].longitude)
            }
            this.firstStartup = false
          }
          this.callingShowPointData = false
        })
        .catch(error => {
          // TODO エラー処理
          console.log('error', error)
          this.callingShowPointData = false
        })
      }
    },
    createMarker (data) {
      // markerを表示する
      for (let i = 0; i < data.length; i++) {
        const one = data[i]
        const latlng = new google.maps.LatLng(one.latitude, one.longitude)
        let myMarker
        // 既にmarkerがあれば使う、なければ新しく作る
        if (this.markers.length > i) {
          myMarker = this.markers[i]
          myMarker.listener.remove()
          myMarker.info.close()
        } else {
          myMarker = {
            marker: new google.maps.Marker(),
            info: null,
            listener: null
          }
          this.markers.push(myMarker)
        }
        myMarker.marker.setMap(this.map)
        // myMarker.marker.setLabel(one.locationId.toString())
        myMarker.marker.setPosition(latlng)
        myMarker.marker.setZIndex(i + 1)
        // console.log('locationName:' + one.locationName)
        myMarker.info = new google.maps.InfoWindow({
          content: one.locationName
        })
        myMarker.listener = myMarker.marker.addListener('click', () => {
          myMarker.info.open(this.map, myMarker.marker)
        })
      }
      // あまりのmarkerをクリア
      this.clearMarkers(data.length)
    },
    clearMarkers (currentCount) {
      // markerを閉じる domから削除される
      for (let i = currentCount; i < this.markers.length; i++) {
        this.markers[i].listener.remove()
        this.markers[i].info.close()
        this.markers[i].marker.setMap(null)
      }
      const count = this.markers.length
      for (let i = currentCount; i < count; i++) {
        // 微妙にiの増分とpopの削除方向は逆だが気にしないことにする。
        this.markers.pop()
      }
    },
    centerMapLocation (latitude, longitude) {
      // console.log(latitude)
      this.map.setCenter(new google.maps.LatLng(latitude, longitude))
    },
    zoomRounded () {
      let zoom = 2
      if (this.zoom >= 0 && this.zoom <= 9) { zoom = 1 } else
      if (this.zoom > 9 && this.zoom <= 13) { zoom = 2 } else
      if (this.zoom > 13 && this.zoom <= 16) { zoom = 3 } else
      if (this.zoom > 16) { zoom = 4 }
      return zoom
    },
    showWaterSystemSettingsMenu () {
      this.isShowWaterSystemSettingsMenu = true
    },
    showWaterSystemDeleteDialog (device) {
      this.$refs.waterSystemDeleteDialog.startDialog(device)
    },
    reloadWaterSystemList (filtrationSystemId) {
      this.$router.push('/watersystem_list/')
      if (this.isCustomerFormat) {
        // 開いていたデバイス表示は一旦全部閉じる
        this.$refs.customerExpands.forEach(expand => {
          expand.isActive = false
        })
        this.getLocations()
      } else {
        this.getAllFiltrationSystems()
      }
      if (this.selectedFiltrationSystemId === filtrationSystemId) {
        this.selectedFiltrationSystemId = null
        this.$refs.filtrationSystem.filtrationSystemId = null
        this.$refs.filtrationSystem.filtrationSystem = {}
      }
    },
    // ----- /map ------------------------------

    // 表示領域変更用function
    mapToggle () {
      this.active = !this.active
    },
    
    changeSize (size) {
      this.size = size
      
      if (utils.ie11()){
        return
      }
      $('.l-table-wrap')[0].style = null
      $('.l-detail-wrap')[0].style = null
      if (this.HISTORY_style_bak != null) {
        let HISTORY = document.getElementById("HISTORY")
        if (HISTORY != null){
          HISTORY.style.cssText = this.HISTORY_style_bak.cssText
        }
      }
    },

    //// l_detail_bar_grab

    l_detail_bar_move(clientY) {
      if (!this.l_detail_bar_grabbed){
        return
      }
      const Adjust = 90
      if (clientY - Adjust < 90){
        // ヘッダ部の下に潜らないよう止める
        return
      }
      //console.log('l_detail_bar_move ' + clientY)

      this.changeSize('mid')
      
      let l_table_wrap = $('.l-table-wrap')[0]
      let l_table_wrap_height = Math.max(clientY - Adjust, 0)
      l_table_wrap.style.height = l_table_wrap_height + 'px'
      l_table_wrap.style.overflowY = 'scroll'
      //console.log('l_table_wrap.style.height=' + l_table_wrap.style.height)
      
      let l_submain_height = $('.l-submain')[0].offsetHeight
      let l_detail_wrap = $('.l-detail-wrap')[0]
      //console.log('l_submain.offsetHeight=' + l_submain_height)
      let l_detail_wrap_height = l_submain_height - l_table_wrap_height
      l_detail_wrap.style.height = l_detail_wrap_height + 'px'
      
      let HISTORY = document.getElementById("HISTORY")
      if (HISTORY){
        // CSS の l-submain.mid の 500 - 440 に合わせただけ。効果不明
        HISTORY.style.height = Math.max(l_detail_wrap_height - 60, 0) + 'px'
      }
    },

    l_submain_onMouseMove (event) {
      this.l_detail_bar_move(event.clientY)
    },
    
    l_detail_bar_onMouseDown (event) {
      if (utils.ie11()){
        return
      }
      if (this.l_detail_bar_grabbed){
        return
      }
      this.l_detail_bar_grabbed = true
      //console.log('onMouseDown' + 
      //  ' ' + event.clientX +
      //  ',' + event.clientY +
      //  ' l_detail_bar_grabbed=' + this.l_detail_bar_grabbed 
      //)

      if (this.HISTORY_style_bak == null){
        let HISTORY = document.getElementById("HISTORY")
        if (HISTORY){
          this.HISTORY_style_bak = HISTORY.style
        }
      }

      let body = document.getElementsByTagName('body')[0]    
      body.style['-webkit-touch-callout'] = 'none'
      body.style['-webkit-user-select'] = 'none'
      body.style['-khtml-user-select'] = 'none'
      body.style['-moz-user-select'] = 'none'
      body.style['-ms-user-select'] = 'none'
      body.style['user-select'] = 'none'
    },
    
    l_detail_bar_grab_release() {
      if (!this.l_detail_bar_grabbed){
        return
      }
      this.l_detail_bar_grabbed = false
      //console.log('onMouseUp' + 
      //  ' ' + event.clientX +
      //  ',' + event.clientY + 
      //  ' l_detail_bar_grabbed=' + this.l_detail_bar_grabbed 
      //)
      
      let body = document.getElementsByTagName('body')[0]    
      body.style['-webkit-touch-callout'] = 'auto'
      body.style['-webkit-user-select'] = 'auto'
      body.style['-khtml-user-select'] = 'auto'
      body.style['-moz-user-select'] = 'auto'
      body.style['-ms-user-select'] = 'auto'
      body.style['user-select'] = 'auto'
    },
    
    onMouseUp (event) {
      this.l_detail_bar_grab_release()
    },
    
    l_submain_onMouseLeave (event) {
      this.l_detail_bar_grab_release()
    }
  },
  mounted () {
    this.init()
  }
}
</script>

<style>
#locations_table .header__icon {
  display: none !important;
}
#expansion_row {
  line-height: 3em;
}
.service-header {
  white-space: nowrap;
  overflow: hidden;
  text-align: left;
  padding-right: 10px;
}
.expansion-panel__body .list > div {
  padding: 0;
}
.expansion-panel__body .list > div a {
  padding: 0;
}
#locations_table .expansion-panel__header {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjQUFBIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjQxIDcuODRMMTIgMTIuNDJsNC41OS00LjU4TDE4IDkuMjVsLTYgNi02LTZ6Ii8+CiAgICA8cGF0aCBkPSJNMC0uNzVoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==);
  background-position: 98% 10px;
  background-repeat: no-repeat;
  background-size: 25px;
  padding: 0 !important;
}
#locations_table li.expansion-panel__container--active .expansion-panel__header {
  background-image: url(data:image/svg+xml;base64,PHN2ZyBmaWxsPSIjQUFBIiBoZWlnaHQ9IjI0IiB2aWV3Qm94PSIwIDAgMjQgMjQiIHdpZHRoPSIyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICAgIDxwYXRoIGQ9Ik03LjQxIDE1LjQxTDEyIDEwLjgzbDQuNTkgNC41OEwxOCAxNGwtNi02LTYgNnoiLz4KICAgIDxwYXRoIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiLz4KPC9zdmc+Cg==) !important;
}

#locations_table .map_btn {
  min-width: 30px;
  border: 1px solid #CCC !important;
}
 .expansion-panel{
  box-shadow: 0 0px ;
}
.list__tile--link:hover {
  background: rgba(0,155,250,.2);
}
#locations_table .list {
    padding: 0px;
}

.map_float_btn{
  height:50px;
  min-width: 20px !important;
  width: 20px;
  z-index:1;
  right:0px;
}
.l-main.active .map_float_btn{
  right:300px;
}


/* 表示領域変更用css */

.l-main,
.l-submain,
.l-table-wrap,
.l-table-bar,
.l-table,
.l-detail-wrap,
.l_detail_bar,
.l-detail,
.l-map {
  -webkit-box-sizing: border-box;
          box-sizing: border-box; }

.l-main {
  width: 100%;
  height: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: horizontal;
  -webkit-box-direction: normal;
      -ms-flex-direction: row;
          flex-direction: row; }

.l-submain {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column; }

.l-map {
  width: 0;
  height: 100%;
  overflow: hidden;
}

.l-main.active .l-submain {
  width: calc(100% - 300px); }

.l-main.active .l-map {
  width: 300px; }

@media screen and (max-width: 768px) {
  .l-main.active .l-submain {
    width: 100%; }
  .l-main.active .l-map {
    width: 0; }
  .map_btn {
    display: none;}
}

.l-table-wrap {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column; }

.l-detail-wrap {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
      -ms-flex-direction: column;
          flex-direction: column; }



.l-submain.max .l-table-wrap {
  height: 0px;}
.l-submain.max .l-table-bar {
  display: none;}
.l-submain.max .l-table {
  display: none;}
.l-submain.max .l-detail-wrap {
  height: calc(100% - 0px);  }
.l-submain.max .l-detail {
  height: 100%;}

.l-submain.mid .l-table-wrap {
  height: 300px;
  overflow-y: scroll;
}
.l-submain.mid .l-detail-wrap {
  height: 500px; }
.l-submain.mid .l-detail #HISTORY{
  height: 440px;}

.l-submain.min .l-table-wrap {
  height: calc(100% - 35px); }
.l-submain.min .l-detail-wrap {
  height: 35px; }

.l-submain.none .l-detail-wrap {
  height: 0px; }

.l_detail_bar {
  -ms-flex-negative: 0;
      flex-shrink: 0;
  -ms-flex-preferred-size: 30px;
      flex-basis: 30px;
  height: 35px;
  background:linear-gradient(#3C6EAE, #4682CE );
  cursor: row-resize;
}
.l_detail_bar .icon {
  cursor: default;
}

.l-table-bar {
  position: fixed;
  z-index: 1;
}
.l-main .l-table-bar {
  width: 100%;
}
.l-main.active .l-table-bar {
  width: calc(100% - 300px);
}
.l-main .l-table {
  padding-top: 74px;
}
.l-main.active .l-table {
  padding-top: 74px;
}
@media screen and (max-width: 1059px) {
  .l-main.active .l-table.locations {
    padding-top: 97px;
  }
}
@media screen and (max-width: 768px) {
  .l-main.active .l-table-bar {
    width: 100%;
  }
}
@media screen and (max-width: 504px) {
  .l-main.active .l-table {
    padding-top: 111px;
  }
  .l-main.active .l-table.locations {
    padding-top: 124px;
  }
}
@media screen and (max-width: 431px) {
  .l-main.active .l-table {
    padding-top: 131px;
  }
  .l-main.active .l-table.locations {
    padding-top: 144px;
  }
}

.l-table,
.l-detail {
  -webkit-box-flex: 1;
      -ms-flex-positive: 1;
          flex-grow: 1;
  overflow-y: scroll;
  -ms-overflow-style: none; }
  .l-table::-webkit-scrollbar,
  .l-detail::-webkit-scrollbar {
    display: none; }

.l-submain,
.l-map,
.l-table-wrap,
.l-detail-wrap {
  /* height は l_detail_bar_grab との相性が悪いので設定しない 
   * https://aplix.backlog.com/view/HARPS-636#comment-13082152 */
  -webkit-transition: width 300ms ease;
  transition: width 300ms ease;
}

.icon-hover:hover {
  background-color: #6291C4;
}
a.sortable {
  cursor: pointer;
  color: inherit;
}
</style>



// WEBPACK FOOTER //
// WaterSystemList.vue?79a5bb1a